module.exports = __webpack_public_path__ + "img/EY.c7c4543e.jpg";